import { Component } from "react";
import { Paper } from "@mui/material";

export class WidePaper extends Component {
  render() {
    return (
      <Paper {...this.props} style={{ ...this.props.style, width: 350 }} />
    );
  }
}
